module.exports = __webpack_public_path__ + "static/img/1666832102195.65f95cf2.png";